import React, { PropsWithChildren } from 'react'
import Slider from 'react-slick'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { ItemType } from '../../slices/LogoGrid'
import LogoListCard from './LogoListCard'
import classes from './ResponsiveSlider.module.scss'

const ResponsiveSlider: React.FC<PropsWithChildren<{ data: ItemType[]; light_bg: boolean }>> = ({ data, light_bg }) => {
  const isMobile = useMediaQuery('(max-width: 1023px)')

  return (
    <div className={classes.carousel}>
      <div className={classes.carousel__container}>
        <Slider
          className={classes.carousel__slider}
          dots={true}
          arrows={false}
          slidesToShow={isMobile ? 1 : 3}
          slidesToScroll={isMobile ? 1 : 3}
        >
          {data && data?.length > 0 && data.map((card, idx) => (
            <div key={idx} className={classes.carousel__inner_slide}>
              <LogoListCard light_bg={light_bg} card={card}/>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}


export default ResponsiveSlider
